"use strict";
exports.__esModule = true;
exports.toCard = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var cta_1 = require("./cta");
var toCard = function (data, logger) {
    var prismicCard = utils_1.unprefix('card', data);
    if (prismicCard) {
        return utils_1.compact({
            image: fields_1.toImage(prismicCard.image, logger),
            title: fields_1.toText(prismicCard.title),
            description: fields_1.toText(prismicCard.subtitle),
            cta: cta_1.toCta(prismicCard, logger)
        });
    }
};
exports.toCard = toCard;
//# sourceMappingURL=card.js.map